<template>
    <div class='main'>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item><i class='el-icon-lx-profile'>数据存储</i></el-breadcrumb-item>
                <el-breadcrumb-item>数据详情</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class='container' style='min-width: 900px'>
            
            <el-container style='border: 1px solid #eee'>
                <el-aside width='200px' style='background-color: rgb(238, 241, 246)'>
                    <el-menu @select='handleMenuSelect'>
                        <el-submenu index='1-2'>
                            <template slot='title'>数据存储</template>
                            <el-menu-item index='createClass'>创建Class</el-menu-item>
                            <el-menu-item v-if='computeShowClass(item)' v-for='(item, index) in schemaList'
                                          :index='`schema-${item.objectId}`'
                                          :key='index'>{{ item.objectId }}
                            </el-menu-item>
                            <el-divider>用户</el-divider>
                            <el-menu-item v-for='(item, index) in internalClassList.user' :index='`schema-${item.name}`'
                                          :key='index'>{{ item.name }}
                            </el-menu-item>
                        </el-submenu>
                        
                        <el-submenu index='1-3'>
                            <template slot='title'>服务设置</template>
                            <el-menu-item index='settings'>设置</el-menu-item>
                            <el-menu-item index='requestDetails'>日志</el-menu-item>
                        </el-submenu>
                    </el-menu>
                </el-aside>
                <el-main>
                    <router-view :key='$route.fullPath' />
                </el-main>
            </el-container>
            
            <el-dialog title='创建Class' :close-on-click-modal='true' :close-on-press-escape='true' :show-close='false'
                       :visible.sync='openCreateClass' width='40%'>
                <el-form label-position='top'>
                    <el-form-item label='Class名称'>
                        <el-input v-model='createSchemaInfo.className' size='mini' />
                    </el-form-item>
                    
                    <el-form-item label='Class访问权限'>
                        <class-acl :app-id='queryParams.appId'
                                   :show-button-group='false'
                                   @getAccessInfo='handleGetCLPInfo'
                                   :all-access-info='createSchemaAccessInfo'
                                   :show-authenticated-user-setting='true' />
                    </el-form-item>
                    
                    <el-form-item label='默认ACL权限'>
                        <class-acl :app-id='queryParams.appId'
                                   :show-button-group='false'
                                   :key='new Date().getTime()'
                                   @getAccessInfo='handleGetDefaultACL'
                                   :all-access-info='createSchemaDefaultACL'
                                   :show-data-creator='true'
                                   :show-authenticated-user-setting='false' />
                    </el-form-item>
                </el-form>
                
                <div slot='footer' class='dialog-footer'>
                    <el-button type='primary' @click='handleCreateSchema'>保 存</el-button>
                    <el-button @click='handleCancelCreate'>取 消</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>

import { pageUtil } from '@/utils/pageUtil';
import { message } from '@/utils/message';
import { trackEventApi } from '@api/Track/trackEvent';
import { projectInfoApi } from '@api/ProjectInfo';
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
import bus from '@/components/common/bus';
import { storageSchemaApi } from '@api/Storage/storageSchema';
import ClassEdit from '@/components/component/storage/ClassEdit.vue';
import ClassAcl from '@/components/component/storage/ClassAcl.vue';
import { packageACLInfo } from '@/utils/storage';

export default {
    name: 'User',
    components: {
        ClassAcl,
        ClassEdit,
        VueJsonPretty
    },
    data() {
        return {
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            // 总条数
            total: 0,
            // 弹出层标题
            title: '',
            updateStatus: false,
            // 是否显示弹出层
            open: false,
            // 查询参数
            queryParams: {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                sortSqlList: [
                    'createTime desc'
                ],
                
                appId: undefined
            },
            
            trackDataList: [],
            trackEventList: [],
            currentTrackData: {},
            eventMap: new Map,
            mapTrackerNum: 1,
            projectInfoList: [],
            
            schemaList: [],
            openCreateClass: false,
            createSchemaInfo: {},
            createSchemaAccessInfo: {
                ADD_FIELD: {
                    allowAll: true
                },
                CREATE: {
                    allowAll: true
                },
                UPDATE: {
                    allowAll: true
                },
                DELETE: {
                    allowAll: true
                },
                QUERY: {
                    allowAll: true
                },
                QUERY_BY_OBJECT_ID: {
                    allowAll: true
                }
            },
            createSchemaDefaultACL: {
                read: {
                    allowAll: true
                },
                write: {
                    allowAll: true
                }
            },
            
            defaultCreateSchemaAccessInfo: {
                ADD_FIELD: {
                    allowAll: true
                },
                CREATE: {
                    allowAll: true
                },
                UPDATE: {
                    allowAll: true
                },
                DELETE: {
                    allowAll: true
                },
                QUERY: {
                    allowAll: true
                },
                QUERY_BY_OBJECT_ID: {
                    allowAll: true
                }
            },
            defaultCreateSchemaDefaultACL: {
                read: {
                    allowAll: true
                },
                write: {
                    allowAll: true
                }
            },
            internalClassList: {
                user: [
                    {
                        label: '_User',
                        value: '_internal_User',
                        name: '_User'
                    },
                    {
                        label: '_Role',
                        value: '_internal_Role',
                        name: '_Role'
                    }
                ]
            }
        };
    },
    computed: {
        computeShowClass() {
            return t => {
                let className = t.objectId;
                let concat = this.internalClassList.user.map(t => t.name).concat();
                return !concat.includes(className);
            };
        },
        computeEventName() {
            return (data) => {
                let event = this.eventMap.get(parseInt(data.eventId));
                if (!event) {
                    return '未知';
                } else {
                    return event.eventName;
                }
            };
        },
        computeUserAccount() {
            return (data) => {
                // let user = this.adminUserMap.get(data.createUserId)
                // if (!user) {
                //     return '未知'
                // }else {
                //     return user.nickName
                // }
            };
        }
    },
    created() {
        this.setInitValue();
        this.initData();
        // 监听eventBus
        bus.$on('queriedTrackProjectAppId', t => {
            this.queryParams.projectAppId = t;
            this.queryTrackEvent(t);
        });
        bus.$on('queriedTrackEventId', t => {
            this.queryParams.eventId = t;
        });
    },
    methods: {
        handlePagination(pageNum) {
            this.queryParams.pageNum = pageNum;
            this.getList();
        },
        handleSizeChange(size) {
            this.queryParams.pageSize = size;
            this.queryParams.pageNum = 1;
            this.getList();
        },
        async handleSortChange({ column, prop, order }) {
            await pageUtil.handleSortChange(prop, order, this.queryParams.sortSqlList);
            this.queryParams.pageNum = 1;
            this.queryParams.pageSize = 15;
            this.getList();
        },
        initData() {
            this.eventMap = new Map;
            this.trackEventList = [];
            this.projectInfoList = [];
            
            projectInfoApi.query({ pageSize: 10000 }).then(result => {
                if (result.code === 200) {
                    this.projectInfoList = result.data.result;
                }
            });
        },
        getList() {
            this.loading = true;
            
            storageSchemaApi.queryAllSchema(this.queryParams.appId).then(result => {
                if (result.code === 200) {
                    this.schemaList = (result.data.results || []).sort((a, b) => a.objectId.localeCompare(b.objectId, 'en', { sensitivity: 'base' }));
                }
            });
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.getList();
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams = {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                sortSqlList: [
                    'createTime desc'
                ]
            };
            this.handleQuery();
        },
        resetQueryPage() {
            this.queryParams.pageNum = 1;
            this.queryParams.pageSize = 15;
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.userId);
            this.updateStatus = true;
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.open = true;
            this.title = '分配分组';
            this.updateStatus = false;
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.currentDataInfo = row;
            this.open = true;
            this.updateStatus = true;
            this.title = '修改事件信息';
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            let obj = this;
            this.$modal.confirm('是否确认删除"' + row.eventName + '"的数据项？').then(function() {
                return;
            }).then((result) => {
                if (result.code === 200) {
                    obj.getList();
                    message.success(result.message);
                }
            }).catch(() => {
            });
        },
        /** 提交按钮 */
        submitForm: function() {
        
        },
        async handleProjectSelectChange(projectAppId) {
            if (!projectAppId) {
                message.error('请选择项目!');
            }
            // 根据appId查询事件
            trackEventApi.queryTrackEvent({ projectAppId: projectAppId, pageSize: 10000 }).then(result => {
                if (result.code === 200) {
                    this.trackEventList = result.data.result;
                    result.data.result.forEach(t => {
                        this.eventMap.set(parseInt(t.id), t);
                        this.mapTrackerNum = this.mapTrackerNum + 1;
                    });
                    
                    if (this.trackEventList.length === 0) {
                        message.error('当前项目无任何埋点事件!');
                    } else {
                        if (this.queryParams.projectAppId) {
                            bus.$emit('selectedTrackProjectAppId', this.queryParams.projectAppId);
                        }
                    }
                }
            });
        },
        async queryTrackEvent(projectAppId) {
            if (!projectAppId) {
                return;
            }
            // 根据appId查询事件
            trackEventApi.queryTrackEvent({ projectAppId: projectAppId, pageSize: 10000 }).then(result => {
                if (result.code === 200) {
                    this.trackEventList = result.data.result;
                    result.data.result.forEach(t => {
                        this.eventMap.set(parseInt(t.id), t);
                        this.mapTrackerNum = this.mapTrackerNum + 1;
                    });
                }
            });
        },
        handleMenuSelect(index, indexPath) {
            if (index === 'createClass') {
                this.openCreateClass = true;
                return;
            }
            if (index.startsWith('schema')) {
                let indexArr = index.split('-');
                let schemaName = indexArr[1];
                this.$router.push(`/storage-info/${this.queryParams.appId}/data/${schemaName}`);
            } else {
                this.$router.push(`/storage-info/${this.queryParams.appId}/${index}`);
            }
        },
        
        setInitValue() {
            this.queryParams.appId = undefined;
            if (this.$route.params.appId && this.$route.params.appId.indexOf('undefined') === -1) {
                this.queryParams.appId = this.$route.params.appId;
            }
            if (!this.queryParams.appId) {
                message.error('请选择应用!');
                this.$router.push(`/storage-application`);
                return;
            }
            this.getList();
        },
        handleGetCLPInfo(accessInfo) {
            this.createSchemaInfo.classLevelPermission = accessInfo;
        },
        async handleGetDefaultACL(accessInfo) {
            let aclInfo = await packageACLInfo(accessInfo);
            this.createSchemaInfo.metadata = {
                default_acp: aclInfo
            };
        },
        handleCreateSchema() {
            let className = this.createSchemaInfo.className;
            if (!className) {
                message.error('Class名称不能为空!');
                return;
            }
            storageSchemaApi.createSchema(className, this.createSchemaInfo, this.queryParams.appId).then(result => {
                if (result.code === 200) {
                    this.openCreateClass = false;
                    message.success(result.message);
                    this.createSchemaInfo = {};
                    this.getList();
                    this.$router.push(`/storage-info/${this.queryParams.appId}/data/${className}`);
                }
            });
        },
        handleCancelCreate() {
            this.openCreateClass = false;
            this.createSchemaInfo = {};
            this.createSchemaDefaultACL = this.defaultCreateSchemaDefaultACL;
            this.createSchemaAccessInfo = this.defaultCreateSchemaAccessInfo;
        }
    }
};
</script>
